import { decryptData } from "@flexibees/core";
import { API } from "../constants/api";
import {
  axiosGetWithToken,
  axiosMediaUpload,
  axiosPut,
} from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";

export const VIEW_PROJECT_DETAILS = "VIEW_PROJECT_DETAILS";
export const VIEW_PROJECT_INFO = "VIEW_PROJECT_INFO";

export const viewProject = (id, disableLoader) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const projectId = decryptData(id);

    axiosGetWithToken(`${API.VIEW_PROJECT}/${projectId}/`, token)
      .then((res) => {
        console.log("REASA", res.data.data);
        if (res.data.status_code === 200) {
          dispatch({
            type: VIEW_PROJECT_DETAILS,
            payload: res.data.data,
          });
          disableLoader();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (err && err.response && err.response.data) ||
            "Something went wrong.",
        });
      });
  };
};

export const updateAssignment = (id, data, disableButton) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const projectId = decryptData(id);
    axiosPut(`${API.UPDATE_ASSIGNMENT}/${projectId}/`, data, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          disableButton();
          dispatch({
            type: SUCCESS_ALERT,
            payload: res.data.data.message,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message,
          });
        }
      }
    );
  };
};

export const viewProjectInfo = (id) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    axiosGetWithToken(`${API.VIEW_PROJECT_INFO}/${id}/`, token).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: VIEW_PROJECT_INFO,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: "Something went wrong.",
        });
      }
    });
  };
};

export const uploadAssignment = (file, update) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    axiosMediaUpload(API.MEDIA_UPLOAD, "pdf", file, token).then((res) => {
      if (res.data.status_code === 200) {
        update(res.data.data);
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Assignment has uploaded successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: res.data.data.message,
        });
      }
    });
  };
};
